// extracted by mini-css-extract-plugin
export default {"loginLogo":"LoginPage_loginLogo__aB809"};